import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';

import { environment } from '../../../../environments/environment';

import {
  EmailBukTicket,
  ImprintEmailBukTicket,
  ImprintLinkBukTicket,
  LinkBukTicket,
} from '../../models/buk-ticket.model';

import { FilterItem } from '../filter/filter.component';

const allColumns = [
  'no',
  'contentTitle',
  'issuedAt',
  'expiredAt',
  'issuedTo',
  'activatedBy',
  'activatedAt',
  'issuedCount',
  'activatedCount',
  'activatedRatio',
  'downloadURL',
  'period',
];

@Component({
  selector: 'app-buk-ticket-list-view',
  templateUrl: './buk-ticket-list-view.component.html',
  styleUrls: ['./buk-ticket-list-view.component.scss'],
})
export class BukTicketListViewComponent {
  @Input() columns = allColumns;
  @Input() sortBy: string;
  @Input() isSortOrderDesc: boolean;
  @Input() set FilterItems(filterItems: {
    issuedEmails: FilterItem[];
    activatedEmails: FilterItem[];
  }) {
    this.issuedEmails = filterItems.issuedEmails;
    this.activatedEmails = filterItems.activatedEmails;
  }

  @Input()
  set items(
    items:
      | ImprintEmailBukTicket[]
      | ImprintLinkBukTicket[]
      | EmailBukTicket[]
      | LinkBukTicket[]
  ) {
    const now = moment();

    this._items = items?.map((item) => ({
      ...item,
      isExpired: !item.expired_at ? false : now.isAfter(item.expired_at),
    }));
  }

  @Output() sortClick = new EventEmitter<{
    column: string;
    isSortOrderDesc?: boolean;
    checkedItems?: string[];
  }>();

  public _items: ((
    | ImprintEmailBukTicket
    | ImprintLinkBukTicket
    | EmailBukTicket
    | LinkBukTicket
  ) & {
    isExpired: boolean;
  })[];

  public readonly _bukOrigin = environment.bukOrigin;

  public issuedEmails: FilterItem[];
  public activatedEmails: FilterItem[];

  onAction(
    event: {
      type: string;
      isSortOrderDesc?: boolean;
      checkedItems?: string[];
    },
    column: string
  ): void {
    switch (event.type) {
      case 'onSortLabelClick':
        this.onSortLabelClick(
          column,
          event.isSortOrderDesc,
          event.checkedItems
        );
        break;
      case 'closeFilterMenu':
        this.closeFilterMenu(column, event.checkedItems);
        break;
    }
  }

  onSortLabelClick(
    column: string,
    isSortOrderDesc: boolean,
    checkedItems: string[]
  ): void {
    this.sortClick.emit({
      column,
      isSortOrderDesc,
      checkedItems,
    });
  }

  closeFilterMenu(column: string, checkedItems: string[]): void {
    this.sortClick.emit({
      column,
      isSortOrderDesc: false,
      checkedItems,
    });
  }

  selectedEmails(column: string): string[] {
    if (column === 'issuedTo') {
      return this.issuedEmails
        .filter((email) => !!email.checked)
        .map((email) => email.id);
    } else {
      return this.activatedEmails
        .filter((email) => !!email.checked)
        .map((email) => email.id);
    }
  }
}
